// extracted by mini-css-extract-plugin
export default {"host":"Folder_host__CRfES","icon":"Folder_icon__gvsOZ"};